import React, { useState, memo, useEffect } from 'react'
import Modal from './Modal'
import { brandsDiv, activeBrandsDiv, currentKmList } from '../../functions/stateList'
import SelectKm from '../content/views/service/new/SelectKm'

function BrandsModal({
  label,
  activeFilter,
  setShowBrands,
  list,
  services,
  setServices,
  inputs,
  setInputs,
}) {
  const [brandId, setBrandId] = useState(null)
  const [km, setKm] = useState(null)
  const [selectKm, setSelectKm] = useState(false)

  useEffect(() => {
    setKm(inputs?.[`useful_km${label}`])
    setBrandId(inputs?.[`product${label}`])
  }, [])

  const brandHandler = (id, type) => {
    if (type === 'brand') {
      if (brandId === id) {
        setBrandId(null)
      } else {
        setBrandId(id)
      }
    } else {
      if (km === id) {
        setSelectKm(false)
        setKm(null)
      } else {
        setKm(id)
        setSelectKm(true)
      }
    }
  }

  const modalHandler = () => {
    services.push({
      product: brandId,
      useful_km: km,
      type: label,
      description: 'changed',
      service_category: activeFilter,
    })
    const key = 'type'
    const unique = [...new Map(services.map((item) => [item[key], item])).values()]

    let currentList = unique.filter((service) => service?.service_category === activeFilter)
    let queryParams = {}
    for (let item of currentList) {
      queryParams[item?.type] = item?.description
      if (item?.description === 'changed') {
        queryParams[`product${item?.type}`] = item?.['product']
        queryParams[`useful_km${item?.type}`] = item?.useful_km
      }
    }
    setInputs({
      ...inputs,
      ...queryParams,
    })

    setServices([...unique])
    setShowBrands(false)
  }

  return (
    <Modal isLargeModal={true}>
      <div>
        {/*header*/}

        <div className="flex items-center justify-between mb-8">
          <h3 className="text-xl md:text-3xl font-semibold text-center dark:text-slate-200">
            برند {label}
          </h3>
          <i
            className={
              'icon-close-circle bg-light-gray dark:bg-slate-600 dark:text-amber-50 w-10 h-10 flex items-center justify-center rounded-md text-2xl mr-4 cursor-pointer'
            }
            onClick={() => setShowBrands(false)}
          />
        </div>

        {/*brands*/}
        <div className="flex flex-wrap gap-x-8 gap-y-6 mb-12">
          {list &&
            list?.map((item) => (
              <div
                key={item?.id}
                className={brandId === item?.id ? activeBrandsDiv : brandsDiv}
                onClick={() => brandHandler(item?.id, 'brand')}
              >
                {item?.name}
              </div>
            ))}
        </div>

        {/*km*/}
        <h3 className="text-xl md:text-2xl font-semibold text-right mb-8 dark:text-slate-200">
          میزان کارکرد
        </h3>
        <div className="flex flex-wrap gap-x-8 gap-y-6">
          {currentKmList &&
            currentKmList?.map((list) => (
              <div
                key={list}
                className={km === list ? activeBrandsDiv : brandsDiv}
                onClick={() => brandHandler(list, 'km')}
              >
                {list}
              </div>
            ))}
        </div>
        {!selectKm && <SelectKm km={km} setKm={setKm} />}

        {/*footer*/}
        <button
          type={'button'}
          onClick={modalHandler}
          className={
            'block mr-auto ml-0 bg-blue rounded-md text-white font-semibold py-4 px-6 mt-12'
          }
        >
          ثبت اطلاعات
        </button>
      </div>
    </Modal>
  )
}

export default memo(BrandsModal)
